import React, { useState, ReactNode } from "react";
import { motion } from "framer-motion";
import Button from "@/common/ui/Button";
import useClickOutside from "@/hooks/useClickOutSide";

interface ButtonModalProps {
  children: ReactNode;
  modalContent: React.ReactNode;
}

const ButtonModal: React.FC<ButtonModalProps> = ({ children, modalContent }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleModal = () => {
    setIsOpen((pre) => !pre);
  };

  const modalRef = useClickOutside(() => setTimeout(() => setIsOpen(false), 100));

  return (
    <div className="relative">
      <Button variant="transparent" size="none" onClick={toggleModal}>
        {children}
      </Button>
      {isOpen && (
        <motion.div
          ref={modalRef}
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 50 }}
          transition={{ duration: 0.3 }}
          className="absolute top-10 -right-2 md:right-0 transform min-w-48 bg-white shadow-lg rounded-md border z-50"
        >
          {React.cloneElement(modalContent as React.ReactElement<any>, { onClose: toggleModal })}
        </motion.div>
      )}
    </div>
  );
};

export default ButtonModal;
